import { Box, Typography } from '@material-ui/core';
import React from 'react';

import useStyles from './style';

type IProps = {
  title: string;
};

const BarberShopTitle: React.FC<IProps> = ({ title }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        {title}
      </Typography>
    </div>
  );
};

export default BarberShopTitle;
